import { SuccessResponse } from "common/common.interface";
import { useAppDispatch, useSnack } from "common/hooks";
import { useMutationWithLoading } from "common/hooks/src/api/useMutationWithLoading";
import { setUser } from "modules/auth/store";
import {
    AuthenticatedUser,
    ISignInWithUserPasswordPayload,
    WorkspaceUserRole,
} from "modules/auth/types/auth.interface";
import { UseMutationResult } from "react-query";
import { getAuthBackend } from "./backends";

export const useSignIn = (): UseMutationResult<
  AuthenticatedUser,
  Error,
  ISignInWithUserPasswordPayload
> => {
  const setSnack = useSnack();
  const dispatch = useAppDispatch();

  const signInUser = async (
    credentials: ISignInWithUserPasswordPayload
  ): Promise<AuthenticatedUser> => {
    const authBackend = await getAuthBackend();
    return await authBackend.signInWithEmailPassword(credentials);
  };

  return useMutationWithLoading(
    (credentials: ISignInWithUserPasswordPayload) => signInUser(credentials),
    {
      onSuccess(data: AuthenticatedUser) {
        if (data.role !== WorkspaceUserRole.SuperAdmin) {
          setSnack({
            title: "Vous n'êtes pas autorisé à accéder à cette page!",
            severityType: "error",
          });
          return;
        }

        dispatch(setUser({ user: data }));
      },
      onError() {
        setSnack({
          title: "Mots de passe ou email incorrect!",
          severityType: "error",
        });
      },
    }
  );
};

export const useSendResetPassword = (): UseMutationResult<
  SuccessResponse,
  Error,
  string
> => {
  const setSnack = useSnack();

  const sendResetPassword = async (email: string): Promise<SuccessResponse> => {
    const authBackend = await getAuthBackend();
    return await authBackend.sendResetPassword(email);
  };

  return useMutationWithLoading((email: string) => sendResetPassword(email), {
    onError() {
      setSnack({
        title: "Mots de passe ou email incorrect!",
        severityType: "error",
      });
    },
  });
};
